import { ROLES } from 'src/types/Employee';
import { ROLES_OPTION } from 'src/components/enterprise/features/Employee/utils/employeeRoles.utils';

export const getRolesOptions = (
  options: ROLES_OPTION[],
  isInternalAdminUser: boolean,
  isPermissionsFieldDisabled: boolean
): ROLES_OPTION[] => {
  return isInternalAdminUser || isPermissionsFieldDisabled
    ? options
    : options.filter((role) => role.value !== ROLES.FINANCIAL_ADMIN);
};
